import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from './store'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'

if (process.env.NODE_ENV === 'development') {
  Vue.config.backend_base_url = 'http://localhost:8000'
} else {
  Vue.config.productionTip = true;
  Vue.config.backend_base_url = 'http://meteo.caldesdemalavella.cat:7575' // TODO
}

Highcharts.setOptions({
  time: {
    useUTC: false
  },
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    loading: 'Carregant dades...',
    months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'],
    weekdays: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
    shortMonths: ['Gen', 'Febr', 'Març', 'Abr', 'Maig', 'Juny', 'Jul', 'Ag', 'Set', 'Oct', 'Nov', 'Des'],
    exportButtonTitle: "Exportar",
    printButtonTitle: "Impremer",
    rangeSelectorFrom: "Des de",
    rangeSelectorTo: "Fins",
    rangeSelectorZoom: "Amplia",
    downloadPNG: 'Descarrega en imatge PNG',
    downloadJPEG: 'Descarrega en imatge JPEG',
    downloadPDF: 'Descarrega en document PDF',
    downloadSVG: 'Descarrega en imatge SVG',
    resetZoom: "Restableix el zoom",
    resetZoomTitle: "Restableix el zoom"
  }
});

Vue.use(Vuex);
Vue.use(HighchartsVue);

// Global registration
Vue.use(VueAxios, axios)
axios.defaults.baseURL = Vue.config.backend_base_url + '/api/v1'

/* new Vue({ */
window.vue = new Vue({ // DEBUG HACK
  store,
                       router,
                       vuetify,
                       render: h => h(App),
}).$mount('#app')
